import ChildcareService from '@/services/childcareService'

export default {
  getChildcareEnrollmentSteps({ commit, dispatch }: any) {
    return ChildcareService.getChildcareEnrollmentSteps().then(success => {
      commit("setChildcareEnrollmentStep", success.data);

      if (success.data == -1) {
        commit("setCurrentChildcareEnrollmentStep", success.data);
      }
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },

  getBadges({ commit, dispatch }: any, badgesNames: any = null) {
    return ChildcareService.getBadges(badgesNames).then(success => {
      let badges = success.data.badges;
      let isOnlyBadges = false;

      commit("updateBadges", {
        badges: badges,
        isOnlyBadges: isOnlyBadges,
        badgesNames: badgesNames
      });

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },

  getHomeSafety({ commit, dispatch }: any) {
    return ChildcareService.getHomeSafety().then(success => {
      commit("updateHomeSafety", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },

  getChildcareLocation({ commit, dispatch }: any) {
    return ChildcareService.getChildcareLocation().then(success => {
      commit("updateChildcareLocation", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },

  getChildcareLocationById({ commit, dispatch }: any, providerId: any) {
    return ChildcareService.getChildcareLocationById(providerId).then(success => {
      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  }, 

  getAvailabilitySettings({ commit, dispatch }: any) {
    return ChildcareService.getAvailabilitySettings().then(success => {
      commit("updateAvailabilitySettings", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    })
  },

  getHoursOfBusiness({ commit }: any) {
    return ChildcareService.getHoursOfBusiness().then(success => {
      commit("updateHoursOfBusiness", success.data.hoursOfBusiness);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },

  getPrices({ commit, dispatch }: any) {
    return ChildcareService.getPrices().then(success => {
      commit("updatePrices", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },

  getCancellationOptions({ commit, dispatch }: any) {
    return ChildcareService.getCancellationOptions().then(success => {
      commit("updateCancellationOptions", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },

  getPolicies({ commit, dispatch }: any) {
    return ChildcareService.getPolicies().then(success => {
      commit("updatePolicies", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },

  getProviderPolicies({ commit, dispatch }: any) {
    return ChildcareService.getProviderPolicies().then(success => {
      commit("updateProviderPolicies", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },
 
  getNotifications({ commit, dispatch }: any) {
    return ChildcareService.getNotifications().then(success => {
      commit("updateNotifications", success.data);

      return Promise.resolve(success.data);
    }, error => {
      return Promise.reject(error);
    });
  },

  getProgramStatement({ commit, dispatch, state }: any) {
    return ChildcareService.getProgramStatement().then(success => {
      if (success.data.text) {
        commit('updateProgramStatement', success.data);

        return Promise.resolve(success.data);
      }
      return state.enrollmentFormsContainer.programStatement;

    })
  },

  getParentBookingMethod({ commit, dispatch }: any) {
    return ChildcareService.getParentBookingMethod().then(success => {
      commit('updateParentBookingMethod', success.data);

      return Promise.resolve(success.data);
    })
  },
  
  getHouseholdInfo({ commit, dispatch }: any) {
    return ChildcareService.getHouseholdInfo().then(success => {
      commit('updateHousehold', success.data);

      return Promise.resolve(success.data);
    })
  },
  
  getFamilyAmenities({ commit, dispatch }: any) {
    return ChildcareService.getFamilyAmenities().then(success => {
      commit('updateFamilyAmenities', success.data);
      
      return Promise.resolve(success.data);
    })
  },
  
  getHistory({ commit, dispatch }: any) {
    return ChildcareService.getHistory().then(success => {
      return Promise.resolve(success.data);
    })
  },
  
  getProviderBookingHistory({ commit, dispatch }: any) {
    return ChildcareService.getHistory().then(success => {
      //commit('updateFamilyAmenities',success.data);
      return Promise.resolve(success.data);
    })
  },
  
  getHolidays({ commit }: any) {
    return ChildcareService.getHolidays().then(success => {
      return Promise.resolve(success);
    }, error => {
      return Promise.reject(error);
    });
  }
}